module.exports = __webpack_public_path__ + "static/media/pen-svgrepo-com.639bdb35.svg";